<template>
	<v-content>
		<v-progress-linear
			class="progress-bar"
			v-bind:indeterminate="showIndeterminate"
			v-if="showIndeterminate">
		</v-progress-linear>
		<app-header
			:quantity-notifications="quantityNotifications"
			v-on:open-notifications-event="openNotificationsModal"
		/>
		<v-container fluid pa-0>
			<slot></slot>
			<action-sidebar
				:width="action.width"
				v-model="action.open"
				v-bind:code-action="action.code"
				v-bind:title="action.title"
				v-bind:active="action.active"
				v-bind:img-src="action.imgSrc"
				v-bind:is-loading="loading"
				v-bind:header-color="action.color">
			</action-sidebar>
		</v-container>
	</v-content>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appHeader from '@/components/shared/app-header';

function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	this.routes = routes;
}

function notifications() {
	const allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach((productNot) => {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach((saleNot) => {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468,
		},
		isVisible: true,
		loading: false,
		routes: [],
	};
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

export default {
	name: 'layout-admin',
	components: {
		actionSidebar,
		appHeader,
	},
	computed: {
		showIndeterminate,
		notifications,
		quantityNotifications,
	},
	data,
	methods: {
		closeNotificationsModal,
		getRoutes,
		openNotificationsModal,
		toggleSidebar,
	},
};
</script>



// WEBPACK FOOTER //
// src/layouts/layout-admin.vue